// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_88ce71', '__Roboto_Fallback_88ce71', Helvetica, Arial, sans-serif","fontStyle":"normal"},"className":"__className_88ce71"};